import useSWR from "swr"

import { apiClient } from "services/client"
import { IsUnreadReviewRequestData } from "services/reviews"

const isUnreadReviewFetcher = async ({
  url,
  ...params
}: {
  url: string
} & IsUnreadReviewRequestData) => {
  const response = await apiClient.isUnreadReview({
    params: {
      pmcId: params.pmcId,
    },
  })
  return response?.data?.data
}

const useIsUnreadReviewApi = ({ pmcId }: { pmcId: string }) => {
  const response = useSWR(
    pmcId
      ? {
          url: `/is-unread-review-by-pmc`,
          pmcId,
        }
      : null,
    isUnreadReviewFetcher,
    {
      loadingTimeout: 15000,
      revalidateOnFocus: true,
      dedupingInterval: 3000,
      errorRetryCount: 3,
    },
  )

  return response
}
export default useIsUnreadReviewApi
